import React from "react";
import classNames from "classnames";

import MultilineText from "../../MultilineText";
import Address from "../../Address";
import DisplayField from "../DisplayField";
import styles from "./JobEvent.css";
import ActionButtons from "./ActionButtons";
import Details from "./Details";
import Financials from "./Financials";
import Materials from "./Materials";
import Time from "./Time";
import PropTypes from "prop-types";

import { useDrop } from "react-dnd";
import Employee from "../../../AvailableEvents/AvailableEmployees/Employee";
import moment from "moment";
import calendar from "../../../../redux/calendar";
import { isNumber } from "lodash";

const makeStyle = ({ color }) =>
  !color
    ? null
    : {
        borderColor: color,
      };

const getEntityActive = (event, entity) => {
  if (event.job) {
    return entity === "jobs";
  }
  if (event.purchaseOrder) {
    return entity === "purchaseOrders";
  }
  return false;
};

const JobEvent = ({
  className,
  detailEnabled,
  entity,
  event,
  date,
  currentDate,
  financialEnabled,
  locationEnabled,
  materialEnabled,
  showEstimatedQuantities,
  onClick,
  onDeleteEventClick,
  onEditEventClick,
  onOpenClick,
  onPrintWorkOrder,
  showActions,
  styleSelector,
  onRescheduleRes,
  activeEquipment,
  schedulerView,
  mode,
}) => {
  const ondbClick = () => {
    if (schedulerView === "equipment") {
      let evtcrew = event.crew;
      if (evtcrew) {
        evtcrew.equipment = activeEquipment;
        onRescheduleRes(
          event.id,
          currentDate ? currentDate : moment().format(),
          evtcrew,
          mode
        );
      }
    } else {
      onClick();
    }
  };

  const [{ canDrop, isDragging, isOver }, drop] = useDrop({
    accept: ["employee", "crew"],

    canDrop: (item) => {
      switch (item.type) {
        case "employee":
          return true;
        case "crew":
          return true;
        default:
          return false;
      }
    },
    collect: (monitor) => ({
      canDrop: !!monitor.canDrop(),
      isDragging: !!monitor.getItem(),
      isOver: !!monitor.isOver(),
    }),
    drop: (item) => {
      switch (item.type) {
        case "employee":
          const rs = { resource: item.employee };
          let resources = [];
          if (event.crew != null) {
            const existing_resource = event.crew.resources.find(
              (r) => r.resource.id === rs.resource.id
            );
            resources = existing_resource
              ? [...event.crew.resources]
              : [...event.crew.resources, rs];
          } else {
            resources.push(rs);
          }
          const res = { resources: resources };
          let crew = { res };
          if (event.crew != null) {
            crew = { ...event.crew, resources };
          }
          onRescheduleRes(event.id, event.endDate, crew, mode);
          break;
        case "crew":
          onRescheduleRes(event.id, event.endDate, item.standardcrew, mode);
          break;
        default:
          break;
      }
    },
  });
  let showEmployees = false;
  let color = "#304e1e";
  let employeeCheck = "#FFF";

  let curdate = currentDate ? currentDate : moment();
  color = event.crew
    ? moment(curdate).isSame(date, "day")
      ? "#304e1e"
      : "#afd3aa"
    : "#afd3aa";

  if (event.crew && event.crew.resources && schedulerView === "equipment") {
    showEmployees = true;
  }
  return (
    <div
      className={classNames(
        className || styles.container,
        { [styles.inactive]: !getEntityActive(event, entity) },
        { [styles.tentative]: !!event.tentative }
      )}
      // style={
      //   typeof styleSelector === "function"
      //     ? styleSelector(event)
      //     : makeStyle(event)
      // }
      ref={drop}
    >
      <div
        onDoubleClick={
          schedulerView === "equipment" ? () => ondbClick() : onClick
        }
      >
        <div
          style={
            typeof styleSelector === "function"
              ? styleSelector(event)
              : makeStyle(event)
          }
        >
          <h5
            style={{
              textAlign: "left",
              padding: "6px 8px",
              fontSize: "16px",
              fontFamily: "var(--font-family-Fira-Condensed)",
            }}
          >
            <b>{`${event.job.jobNumber || ""}`}</b>
          </h5>
        </div>
        <div className={styles.jobEventHeader}>
          <DisplayField group="general" field="jobName">
            <p>
              <b
                style={{
                  color: "var(--Neutral-850)",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >{`${event.job.name || ""}`}</b>
            </p>
          </DisplayField>
          <Time event={event} />
          {detailEnabled && (
            <DisplayField group="details" field="description">
              <MultilineText text={event.description} />
            </DisplayField>
          )}
          {detailEnabled && <Details event={event} />}
          {locationEnabled && (
            <Address
              address={event.job.address}
              className={styles.address}
              styles={styles}
              multiline
            />
          )}
          {financialEnabled && <Financials event={event} styles={styles} />}
          {materialEnabled && (
            <Materials
              event={event}
              styles={styles}
              showEstimatedQuantities={showEstimatedQuantities}
            />
          )}
          {showEmployees &&
            event.crew.resources.map((e) => {
              if (e.resource !== null) {
                //console.log(e);
                return (
                  <Employee
                    employee={e.resource}
                    key={e.resource.id}
                    color={color}
                    employeeCheck={employeeCheck}
                  />
                );
              }
            })}
        </div>
      </div>
      {showActions && (
        <ActionButtons
          onDeleteEventClick={onDeleteEventClick}
          onEditEventClick={onEditEventClick}
          onOpenClick={onOpenClick}
          onPrintWorkOrder={onPrintWorkOrder}
          showMenuItem={isNumber(event.id)}
        />
      )}
    </div>
  );
};

JobEvent.defaultProps = {
  showActions: true,
};

JobEvent.prototypes = {
  onRescheduleRes: PropTypes.func,
};

export default JobEvent;
